module.exports = __webpack_public_path__ + "img/banner.2fb662a6.png";